// extracted by mini-css-extract-plugin
export default {"tcoButton":"_2AsPL1"};